<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <company-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import CompanyProvider from "../../../providers/CompanyProvider";
    
    import { CrudUpdate } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    
    import CompanyForm from "../CompanyForm";
  
    

    export default {
        name: "CompanyUpdate",
        
        components: { CompanyForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'admin.company.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: this.initializeForm()
            }
        },
        watch: {
            item: {
                handler(newItem) {
                    if (newItem) {
                        this.form = this.initializeForm();
                    }
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            initializeForm() {
                return {
                    id: this.item.id,
                    razonSocial: this.item.razonSocial || null,
                    cuit: this.item.cuit || null,
                    nombreFantasia: this.item.nombreFantasia || null,
                    direccion: this.item.direccion || null,
                    telefono: this.item.telefono || null,
                    emailComercial: this.item.emailComercial || null,
                    emailContacto: this.item.emailContacto || null,
                    // Configuración AFIP
                    afipDomicilioFiscal: this.item.afipDomicilioFiscal || null,
                    afipCondicionIVA: this.item.afipCondicionIVA || null,
                    afipPuntoVenta: this.item.afipPuntoVenta || null,
                    afipAmbiente: this.item.afipAmbiente || 'HOMOLOGACION',
                    afipActivo: this.item.afipActivo || false,
                    envioEmailHabilitado: this.item.envioEmailHabilitado !== false,
                    // Nota: Los certificados no se cargan por seguridad (solo se pueden actualizar)
                    afipCertificadoPEM: null,
                    afipClavePrivadaPEM: null
                };
            },
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    // Convert afipPuntoVenta to number if it exists
                    const formData = {
                        ...this.form,
                        afipPuntoVenta: this.form.afipPuntoVenta ? parseInt(this.form.afipPuntoVenta) : null
                    };
                    CompanyProvider.updateCompany(formData).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.companyUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>
